import { ModalService } from '@app/plugins/iview-modal-modify/service';
import { DataBaseGroupService } from '@db/services/GroupService';
import ItemForm from '@db/components/db-groups/db-groups-modal-create-edit-form';
import i18n from '@app/plugins/i18n';

class GroupModalService extends ModalService {
  constructor() {
    super(DataBaseGroupService);
  }

  remove(id, item) {
    return this.$removeItem(id, item, {
      content: i18n.t('db.group.modal.remove.content', {
        name: `<strong>${item.name}</strong>`
      })
    });
  }

  create() {
    return this.$open({
      title: i18n.t('shared.component.modal.create'),
      width: this.size.confirm,
      render: h =>
        h(ItemForm, {
          on: {
            success: data => {
              this.$emit('success', data);
              this.modal.remove();
            }
          }
        })
    });
  }
}

const instance = new GroupModalService();
export { instance as GroupModalService };
